import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteCheckInOutApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const deleteCheckInOut = createAsyncThunk('deleteCheckInOut', async (payload) => {
  return await deleteCheckInOutApi(payload);
});

const deleteCheckInOutSlice = createSlice({
  name: 'deleteCheckInOut', // Unique Name
  initialState,
  reducers: {
    deleteCheckInOutReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteCheckInOut.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(deleteCheckInOut.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(deleteCheckInOut.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { deleteCheckInOutReset } = deleteCheckInOutSlice.actions;

export default deleteCheckInOutSlice.reducer;
